/* eslint-disable react/no-array-index-key */
import { Skeleton } from 'antd';

interface Props {
  numberItems?: number;
}

const SkeletonAppService = ({ numberItems = 1 }: Props) => (
  <div className="flex flex-col">
    {Array.from({ length: numberItems }).map((_, index) => (
      <Skeleton.Button active className="h-18 mt-4 w-full rounded-lg" key={index} />
    ))}
  </div>
);

export default SkeletonAppService;
